interface Props {
    className?: string;
}

const ASTERISK_PATH =
    'M2.112 10.208L1.2 9.536L3.184 6.816L0 5.76L0.336 4.704L3.52 5.728V2.272H4.704V5.728L7.888 4.704L8.224 5.76L5.04 6.816L7.024 9.536L6.112 10.208L4.112 7.456L2.112 10.208Z';

export function MaskedAsteriskIcon({className = 'h-[0.7em] w-auto'}: Props) {
    return (
        <svg
            viewBox="0 0 8.224 12"
            fill="currentColor"
            aria-hidden="true"
            className={className}
        >
            <path d={ASTERISK_PATH} />
        </svg>
    );
}
